var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('sidebar-fixed-toggle-button'),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.backgroundColor}},[(_vm.dados.tipo === 'F')?_c('top-navbar'):_c('top-navbar-2'),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }